import React from 'react'
import { Link } from 'react-router-dom'
import app from '../../feathers'
import styled from 'styled-components'
import ScrollingDialog from '../../components/ScrollingDialog'
import Button from '../../components/Button'
import { Textfield } from 'react-mdl'
import BlockingSpinner from '../../Units/components/BlockingSpinner'

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`
const InputsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`
const StyledTextfield = styled(Textfield)`
  width: 550px;
`

const userService = app.service('users')

class AddEditUserDialog extends React.Component {
  state = {}

  async componentDidMount() {
    if (this.props.match.params.userId) {
      const usr = await userService.get(this.props.match.params.userId)
      this.setState({ user: usr })
    } else {
      this.setState({
        user: {
          email: '',
          password: '',
          firstName: '',
          lastName: '',
        }
      });
    }
  }

  saveUser = async e => {
    e.preventDefault()

    if (this.state.user._id) {
      delete this.state.user.password;  // updated via reset password
      await userService.patch(
        this.state.user._id,
        this.state.user);
      this.props.history.push('/users/')
    } else {
      await userService.create(this.state.user)
      this.props.history.push('/users/')
    }
  }

  // duplicateUnit = async () => {
  //   const { unit } = this.state
  //   // ensure _id is unique
  //   delete unit._id
  //   // ensure these are current on new unit on creation
  //   delete unit.createdAt
  //   delete unit.updatedAt
  //   const newUnit = await units.create(unit)
  //   this.props.history.push(`/units/${newUnit._id}/`)
  // }

  onChange = ({ target }) => {
    const newVal = { ...this.state.user, [target.name]: target.value };
    this.setState({ user: { ...newVal } })
  }

  render() {
    return (
      <ScrollingDialog
        title="Edit User"
        actions={
          <Container>
            <Link to="/users/">
              <Button>Cancel</Button>
            </Link>
            {this.state.user
              ? <Button
                  primary
                  onClick={this.saveUser}
                  disabled={
                    (!this.state.user.email || !this.state.user.firstName || !this.state.user.firstName || (!this.state.user._id && !this.state.user.password))
                  }
                  onDisabledClick={() =>
                    alert(
                      'Please ensure all fields are filled before attempting to submit form.',
                    )}>
                  {this.state.user && this.state.user._id ? 'Save Changes' : 'Create User'}
                </Button>
              : null
            }

          </Container>
        }>
        {!this.state.user
          ? <BlockingSpinner>
            <h1>Loading...</h1>
          </BlockingSpinner>
          :
          <InputsContainer>
            <Container>
              <StyledTextfield
                name="firstName"
                label="First Name"
                onChange={this.onChange}
                value={this.state.user.firstName}
              />
            </Container>
            <Container>
              <StyledTextfield
                name="lastName"
                label="Last Name"
                onChange={this.onChange}
                value={this.state.user.lastName}
              />
            </Container>
            <Container>
              <StyledTextfield
                required
                name="email"
                label="Email Address"
                onChange={this.onChange}
                value={this.state.user.email}
              />
            </Container>
            {!this.state.user._id
              ? <Container>
                <StyledTextfield
                  required
                  name="password"
                  label="Password"
                  onChange={this.onChange}
                  value={this.state.user.password}
                />
              </Container>
              : <Container></Container>
            }

          </InputsContainer>
        }
      </ScrollingDialog>
    )
  }
}

export default AddEditUserDialog



// WEBPACK FOOTER //
// ./src/Users/UserListScreen/AddEditUserDialog.js